import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Service Imports
// Utility Imports
import { GlobalUtils } from "../../utils/index";
import LZLoader from "../../commonComponents/LZLoader";

// Declarations
class TemplateDetailsGlobal extends Component {
  state = {
    isLoading: false,
  };

  render() {
    const { template = {} } = this.props;
    const {
      id,
      created_at: templateCreatedDate,
      created_by: {
        name: templateOwner,
        image_url: templateOwnerProfileImageUrl,
      } = {},
    } = template;
    if (this.state.isLoading) {
      return (
        <LZLoader
          className="saving-document"
          label="Downloading your esign evidence summary"
          theme="dark"
          fullScreen
        />
      );
    }
    return (
      <div className="context-notes  animated fadeinright">
        <div className="notes-header">
          <span
            data-test="documentdetails-right-pane-title"
            className="right-pane-title documentdetails-pane-title">
            Template information
          </span>
        </div>
        <div
          className={`collab-content collab-content-scroll documentdetails-wrapper`}>
          <div className="content-scroll ">
            {/* Document ID */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "briefcase"]} />
                </span>
                Template ID
              </div>
              <div
                data-test="documentdetails-docinfo-document-id"
                className="documentdetails-col meta-value">
                {id || "-"}
              </div>
            </div>

            {/* Owner */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "user"]} />
                </span>
                Owner
              </div>
              <div className="documentdetails-col meta-value">
                <span className="documentdetails-imgwrapper">
                  <img
                    data-test="documentdetails-docinfo-document-owner-img"
                    className="documentdetails-img"
                    src={templateOwnerProfileImageUrl}
                    alt="Collaborators Profile"
                    height="18px"
                    width="18px"
                  />
                </span>
                <span data-test="documentdetails-docinfo-document-owner">
                  {templateOwner}
                </span>
              </div>
            </div>
            {/* Template Creation Date */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                </span>
                Template Creation Date
              </div>
              <div
                data-test="documentdetails-docinfo-document-creation-date"
                className="documentdetails-col meta-value">
                {GlobalUtils.formatDate(templateCreatedDate, "ll") || "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // ::TEMPLATE STORE
  const { template } = state.TemplateStore;

  return {
    template,
  };
};

export default connect(mapStateToProps, null)(TemplateDetailsGlobal);
